import React from 'react';

export interface ArtProjectsProps {}

const ArtProjects: React.FC<ArtProjectsProps> = () => {
    return <div className="site-page-content" />;
};

export default ArtProjects;
